export enum HeadingType {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

interface IHeading {
  variant: HeadingType;
  content: string;
  className?: string;
  id?: string;
}

export const Heading = ({
  variant,
  content,
  className,
  id,
  ...props
}: IHeading) => {
  const Component = variant ? HeadingType[variant] : 'h6';
  return (
    <>
      <span className="anchor" id={id ? id : content}></span>
      <Component className={className} {...props}>
        {content}
      </Component>
    </>
  );
};
